import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, Navbar } from 'ionic-angular';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { BrComService } from '../../service/BrComService';
import { LoadingController, AlertController } from 'ionic-angular';
import { BrComDao } from '../../service/BrComDao';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AngularFirestore } from '@angular/fire/firestore';
import { readValueFromConfig } from '../../lib/util';
import { PushService } from '../../service/PushService';
import { Network } from '@ionic-native/network';
//import * as firebase from 'firebase';
import { Geolocation } from '@ionic-native/geolocation';
import { NativeGeocoder, NativeGeocoderReverseResult } from '@ionic-native/native-geocoder';
import { filter } from 'rxjs/operators';


var denunciaRegistroPageInstance: DenunciaRegistroPage;

const NUMERO_MIN_CARACTERES_TITULO = 20;
const NUMERO_MAX_CARACTERES_TITULO = 120;
const NUMERO_MAX_CARACTERES_OBSERVACAO = 700;
const NUMERO_MAX_FOTOS = 5;
const QUALIDADE_DA_FOTO = 100;
const LARGURA_DA_FOTO = 640;
const ALTURA_DA_FOTO = 480;

interface localizacao {
  latitute: number,
  longitude: number,
  endereco: string
}

interface denuncia {
  idDenunciaServidor: string,
  codEmpresa: number,
  codUsuario: number,
  titulo: string,
  observacao: string,
  fotos: string[],
  local: localizacao
  timestamp: any
}

interface valorInsercaoDenunciaServidor {
  codUsuario: number,
  codEmpresa: number,
  titulo: string,
  observacao: string,
  timestamp: any,
  local: localizacao,
  fotos: string[]
}

enum componenteFormulario {
  TITULO = "titulo",
  OBSERVACAO = "observacao",
  FOTOS = "fotos",
  LOCAL = "local"
}

enum tituloAlerta {
  ERRO = "ERRO",
  AVISO =  "AVISO"
}

enum collecaoFirestore {
  USUARIO = "usuario",
  DENUNCIAS = "denuncias",
  FOTOS = "fotos"
}

@Component({
  selector: 'page-denunciaregistro',
  templateUrl: 'denunciaregistro.html'
})

@Component({
  selector: 'page-denunciaregistro',
  template: `<textarea fz-elastic></textarea>`
})

export class DenunciaRegistroPage {

  @ViewChild(Navbar) navBar: Navbar;

  private codEmpresa: number;
  public formularioDenuncia: FormGroup;
  private fotos: string[];
  public localizacao:localizacao;

  constructor(private brComService: BrComService, private camera: Camera, private navCtrl: NavController, private navParams: NavParams,
  private loadingCtrl: LoadingController, private brComDao:BrComDao, private network: Network,private formBuilder: FormBuilder, 
  private alertController: AlertController, private db: AngularFirestore, private pushService: PushService,
  private geolocation: Geolocation, private nativeGeocoder: NativeGeocoder) {
    denunciaRegistroPageInstance = this;
    this.formularioDenuncia = this.montarFormularioDenuncia();
    this.fotos = [];
    this.localizacao = {latitute:0,longitude:0, endereco:""};
    this.codEmpresa = navParams.get("codEmpresa");
    this.gerenciarLocalizacao();
  }

  private montarFormularioDenuncia(): FormGroup {
    return denunciaRegistroPageInstance.formBuilder.group({
      [componenteFormulario.TITULO]: ['', Validators.compose([Validators.required, Validators.minLength(NUMERO_MIN_CARACTERES_TITULO), Validators.maxLength(NUMERO_MAX_CARACTERES_TITULO)])],
      [componenteFormulario.OBSERVACAO]: ['',  Validators.maxLength(NUMERO_MAX_CARACTERES_OBSERVACAO)],
      [componenteFormulario.FOTOS]: denunciaRegistroPageInstance.formBuilder.array([]),
      [componenteFormulario.LOCAL]: ['',Validators.required]
    });
  }

  ionViewDidLoad() {
    denunciaRegistroPageInstance.personalizarAcaoBotaoVoltar();
  }

  private personalizarAcaoBotaoVoltar(){
    denunciaRegistroPageInstance.navBar.backButtonClick = () => {
      denunciaRegistroPageInstance.gerenciarSaidaDaTela();
    }
  }

  private gerenciarLocalizacao() {
   /* denunciaRegistroPageInstance.geolocation.watchPosition().filter((p)=> p.coords !== undefined).subscribe(
      function (data) {
        if (data) {
          denunciaRegistroPageInstance.getLocalDenuncia().latitute = data.coords.latitude;
          denunciaRegistroPageInstance.getLocalDenuncia().longitude = data.coords.longitude;
          if (denunciaRegistroPageInstance.getLocalDenuncia().endereco == "") {
            denunciaRegistroPageInstance.definirEndereco();
          }
        } else {
          if (denunciaRegistroPageInstance.getLocalDenuncia().endereco == "") {
            denunciaRegistroPageInstance.getLocalDenuncia().endereco = "Não foi possivel localizar seu endereço atual";
          }
        }
      }
    )*/
  }

  private definirEndereco() {
    const latitudeLocalizacao = denunciaRegistroPageInstance.getLocalDenuncia().latitute;
    const longitudeLocalizacao = denunciaRegistroPageInstance.getLocalDenuncia().longitude;
    denunciaRegistroPageInstance.nativeGeocoder.reverseGeocode(latitudeLocalizacao, longitudeLocalizacao).then(
      function(result: NativeGeocoderReverseResult[]) {
        const enderecoFormatado = denunciaRegistroPageInstance.formatarEndereco(result[0]);
        denunciaRegistroPageInstance.getLocalDenuncia().endereco = enderecoFormatado;
      }
    )
  }

  private formatarEndereco(endereco: NativeGeocoderReverseResult):string {
    const rua = endereco.thoroughfare;
    const numero = endereco.subThoroughfare;
    const bairro = endereco.subLocality;
    const cidade = endereco.locality;
    const estado = endereco.administrativeArea;
    
    return `${rua}, ${numero}, ${bairro} - ${cidade}, ${estado}`;
  }

  private gerenciarSaidaDaTela() { 
    if (denunciaRegistroPageInstance.isFormularioModificado()){
      denunciaRegistroPageInstance.criarConfirmacaoSairDaTela();
    } else {
      denunciaRegistroPageInstance.sairDaPagina();
    }
  }

  private sairDaPagina(){
    denunciaRegistroPageInstance.navCtrl.pop();
  }

  private criarDenuncia(codEmpresa: number, codUsuario: number, titulo: string, observacao: string, fotos: string[], local: localizacao) {

    const timeStampServidor = denunciaRegistroPageInstance.getTimestampServidor();
    const idDenunciaServidor = denunciaRegistroPageInstance.gerarIdUnico(codUsuario, codEmpresa);

    const denuncia: denuncia = {
      idDenunciaServidor: idDenunciaServidor,
      codEmpresa: codEmpresa,
      codUsuario: codUsuario,
      titulo: titulo,
      observacao: observacao,
      fotos: fotos,
      local: local,
      timestamp: timeStampServidor
    };

    return denuncia;
  }

  private criarValorInsercaoDenunciaServidor(denuncia: denuncia):valorInsercaoDenunciaServidor {

    const valorDeInsercao: valorInsercaoDenunciaServidor = {
      codEmpresa: denuncia.codEmpresa,
      codUsuario: denuncia.codUsuario,
      titulo: denuncia.titulo,
      observacao: denuncia.observacao,
      timestamp: denuncia.timestamp,
      local: denuncia.local,
      fotos: denuncia.fotos
    }

    return valorDeInsercao
  }

  private criarParametrosDaCameraFoto(): CameraOptions {

    const parametrosDaCamera: CameraOptions = {
      quality: QUALIDADE_DA_FOTO,
      targetWidth: LARGURA_DA_FOTO,
      targetHeight: ALTURA_DA_FOTO,
      destinationType: denunciaRegistroPageInstance.camera.DestinationType.DATA_URL,
      encodingType: denunciaRegistroPageInstance.camera.EncodingType.JPEG,
      mediaType: denunciaRegistroPageInstance.camera.MediaType.PICTURE
    }

    return parametrosDaCamera
  }

  private criarParametrosDaCameraGaleria(): CameraOptions {

    const parametrosDaCamera: CameraOptions = {
      sourceType: denunciaRegistroPageInstance.camera.PictureSourceType.PHOTOLIBRARY,
      quality: QUALIDADE_DA_FOTO,
      targetWidth: LARGURA_DA_FOTO,
      targetHeight: ALTURA_DA_FOTO,
      destinationType: denunciaRegistroPageInstance.camera.DestinationType.DATA_URL,
      encodingType: denunciaRegistroPageInstance.camera.EncodingType.JPEG,
    }

    return parametrosDaCamera
  }

  public adicionarFoto(foto: string) {
    denunciaRegistroPageInstance.fotos.push(foto);
    denunciaRegistroPageInstance.atualizarFotosFormulario();
  }

  public removerFoto(foto: string) {
    denunciaRegistroPageInstance.fotos.splice(denunciaRegistroPageInstance.fotos.indexOf(foto),1);
    denunciaRegistroPageInstance.atualizarFotosFormulario();
  }

  private atualizarFotosFormulario() {
    const conjuntoDeFotosFormulario = denunciaRegistroPageInstance.formBuilder.array(denunciaRegistroPageInstance.fotos);
    denunciaRegistroPageInstance.formularioDenuncia.setControl(componenteFormulario.FOTOS, conjuntoDeFotosFormulario)
  }

  public selecionarFotoDaGaleria() {
    const parametrosDaCamera = denunciaRegistroPageInstance.criarParametrosDaCameraGaleria();
    denunciaRegistroPageInstance.pegarFoto(parametrosDaCamera);
  }

  public tirarFoto() {
    const parametrosDaCamera = denunciaRegistroPageInstance.criarParametrosDaCameraFoto();
    denunciaRegistroPageInstance.pegarFoto(parametrosDaCamera);
  }

  private pegarFoto(parametrosDaCamera: CameraOptions) {
    if (denunciaRegistroPageInstance.isLimiteDeFotos()){
      denunciaRegistroPageInstance.criarAlertaNumMaxFotosAtingido();
    } else {
      denunciaRegistroPageInstance.camera.getPicture(parametrosDaCamera).then((imagemBase64) => {
        const codEmpresa = denunciaRegistroPageInstance.getCodEmpresa();
        const codUsuario = denunciaRegistroPageInstance.getCodUsuario();
        const foto = imagemBase64;
        denunciaRegistroPageInstance.adicionarFoto(foto);
      }, (erro) => {
        const erroImagemNaoSelecionada = "No Image Selected";
        if (erro != erroImagemNaoSelecionada) {
          denunciaRegistroPageInstance.criarAlertaErroGenerico();
        }
      });
    }
  }

  private criarAlerta(titulo: string, mensagem: string) {
    const alerta = denunciaRegistroPageInstance.alertController.create({
      title: titulo,
      message: mensagem,
      buttons: ["OK"]
    });

    alerta.present();
  }

  private montarDenuncia():denuncia {
    const codEmpresa = denunciaRegistroPageInstance.getCodEmpresa();
    const codUsuario = denunciaRegistroPageInstance.brComService.obtemCodUsuarioDaEmpresa(codEmpresa);
    const titulo = denunciaRegistroPageInstance.getTituloFormulario();
    const observacao = denunciaRegistroPageInstance.getObservacaoFormulario();
    const fotos = denunciaRegistroPageInstance.getFotosFormulario();
    const local = denunciaRegistroPageInstance.getLocalDenuncia();
    const denuncia = denunciaRegistroPageInstance.criarDenuncia(codEmpresa, codUsuario, titulo, observacao, fotos, local);

    return denuncia;
  }

  public async enviarDenuncia() {
    const load = denunciaRegistroPageInstance.criarLoading();
    await load.present();
    const denuncia = denunciaRegistroPageInstance.montarDenuncia();
    denunciaRegistroPageInstance.enviarDadosDenuncia(denuncia);
    denunciaRegistroPageInstance.enviarMensagemDenunciaAdmistradores(denuncia);
    load.dismiss();
    denunciaRegistroPageInstance.criarAlertaEnvioDenuncia();
    denunciaRegistroPageInstance.sairDaPagina();
  }

  private criarAlertaEnvioDenuncia() {
    if(denunciaRegistroPageInstance.isConnectadoInternet()){
      denunciaRegistroPageInstance.criarAlertaSucessoEnvioDenuncia();
    } else {
      denunciaRegistroPageInstance.criarAlertaFalhaEnvioDenuncia();
    }
  }

  private gerarIdUnico(codUsuario: number, codEmpresa: number):string {
    //esse "idDevice" deveria ser um enum em alguma classe que é exportado
    const timestamp = denunciaRegistroPageInstance.getTimeStampLocal();
    const idDevice = readValueFromConfig(denunciaRegistroPageInstance.pushService.localStorageKeyName(), "idDevice");
    return `E${codEmpresa}.U${codUsuario}.D${idDevice}-${timestamp}`;
  }

  private async enviarDadosDenuncia(denuncia: denuncia) {
    const idUsuarioServidor = denunciaRegistroPageInstance.getIdUsuarioServidor();
    const caminhoDaDenuncia = denunciaRegistroPageInstance.getCaminhoColecaoDenuncia(idUsuarioServidor, denuncia.idDenunciaServidor);
    const valorDeInsercaoDenunciaServidor = denunciaRegistroPageInstance.criarValorInsercaoDenunciaServidor(denuncia)

    denunciaRegistroPageInstance.setValorServidor(caminhoDaDenuncia, valorDeInsercaoDenunciaServidor);
  }

  private async enviarMensagemDenunciaAdmistradores(denuncia: denuncia){
    const codUsuario = denuncia.codUsuario;
    const codEmpresa = denuncia.codEmpresa;
    const titulo = denuncia.titulo;
    const observacao = denuncia.observacao;
    const fotos = denuncia.fotos;
    const data = denunciaRegistroPageInstance.brComService.converterTimestampParaDataComHorarioString(new Date());
    const local = denuncia.local.endereco;
    denunciaRegistroPageInstance.brComService.enviarMensagemDenunciaAdmistradores(codUsuario, codEmpresa, titulo, observacao,local, fotos, data);
  }

  private async setValorServidor(caminho: string, valor: valorInsercaoDenunciaServidor) {
    denunciaRegistroPageInstance.db.doc(caminho).set(valor);
  }


  public montarFotoParaVisualizacao(fotoBase64: string):string {
    const codificadorImagemJPEGBase64 = "data:image/jpeg;base64,";
    return codificadorImagemJPEGBase64 + fotoBase64;
  }

  private criarAlertaErroGenerico() {
    const titulo = tituloAlerta.ERRO;
    const mensagem = "Ocorreu um erro inesperado durante o processo"
    denunciaRegistroPageInstance.criarAlerta(titulo, mensagem)
  }

  private criarAlertaNumMaxFotosAtingido() {
    const titulo = tituloAlerta.AVISO;
    const mensagem = `A denúncia tem o limite de ${NUMERO_MAX_FOTOS} fotos.\n\n Para adicionar outra foto é necessário retirar uma existente.`;
    denunciaRegistroPageInstance.criarAlerta(titulo, mensagem)
  }

  private criarAlertaFalhaEnvioDenuncia() {
    const titulo = tituloAlerta.AVISO;
    const mensagem = "Não foi possivel detectar uma conexão com a internet, quando a conexão for reestabelecida a denúncia será enviada automaticamente";
    denunciaRegistroPageInstance.criarAlerta(titulo, mensagem);
  }
  
  private criarAlertaSucessoEnvioDenuncia() {
    const titulo = tituloAlerta.AVISO;
    const mensagem = "A denúncia foi recebida!";
    denunciaRegistroPageInstance.criarAlerta(titulo, mensagem);
  }

  private criarLoading():any {
    const load = denunciaRegistroPageInstance.loadingCtrl.create({
      content: "Por favor aguarde",
      duration: 15000
    })

    return load;
  }

  private criarConfirmacaoSairDaTela() {
    const titulo = tituloAlerta.AVISO;
    const mensagem = "Ao sair desta página qualquer alteração será perdida. Você tem certeza que deseja sair?";
    denunciaRegistroPageInstance.criarAlertaConfirmacao(titulo, mensagem, function(){
      denunciaRegistroPageInstance.sairDaPagina();
    });
  }

  private criarAlertaConfirmacao(titulo: string, mensagem:string, handlerConfirmacao:{():void}){
    const alerta = denunciaRegistroPageInstance.alertController.create({
      title: titulo,
      message: mensagem,
      buttons: [{
        text: "Cancelar",
        role: "cancel"
      }, {
        text: "Confirmar",
        handler: handlerConfirmacao
      }]
    })

    alerta.present();
  }

  public isFormularioModificado():boolean {
    const isTituloModificado = denunciaRegistroPageInstance.isTituloModificado();
    const isObservacaoModificado = denunciaRegistroPageInstance.isObservacaoModificado();
    const isFotosModificadas = denunciaRegistroPageInstance.isFotosModificadas();
    return isTituloModificado || isObservacaoModificado || isFotosModificadas;
  }

  private isTituloModificado():boolean {
    return denunciaRegistroPageInstance.formularioDenuncia.controls.titulo.value != "";
  }

  private isObservacaoModificado():boolean {
    return denunciaRegistroPageInstance.formularioDenuncia.controls.observacao.value != "";
  }

  private isFotosModificadas():boolean {
    return denunciaRegistroPageInstance.formularioDenuncia.controls.fotos.value.length > 0;
  }

  private isLimiteDeFotos():boolean {
    return denunciaRegistroPageInstance.fotos.length == NUMERO_MAX_FOTOS;
  }

  public getLocalDenuncia():localizacao {
    return denunciaRegistroPageInstance.localizacao;
  }

  private getTimestampServidor():any {
    //return firebase.firestore.FieldValue.serverTimestamp();
  }

  private getTimeStampLocal():number {
    return new Date().getTime();
  }

  private getIdUsuarioServidor():string {
    const codEmpresa = denunciaRegistroPageInstance.getCodEmpresa();
    const codUsuario = denunciaRegistroPageInstance.getCodUsuario();
    return `usuario.${codEmpresa}.${codUsuario}`;
  }

  private getCaminhoColecaoUsuario(idUsuarioServidor: string):string {
    return `${collecaoFirestore.USUARIO}/${idUsuarioServidor}`;
  }

  private getCaminhoColecaoDenuncia(idUsuarioServidor: string, idDenunciaServidor: string):string {
    const caminhoColecaoUsuario = denunciaRegistroPageInstance.getCaminhoColecaoUsuario(idUsuarioServidor);
    return `${caminhoColecaoUsuario}/${collecaoFirestore.DENUNCIAS}/${idDenunciaServidor}`;
  }

  private  getCaminhoColecaoFotosDenuncia(idUsuarioServidor: string, idDenunciaServidor: string, idFotoServidor: string) {
    const caminhoColecaoDenuncia = denunciaRegistroPageInstance.getCaminhoColecaoDenuncia(idUsuarioServidor, idDenunciaServidor);
    return `${caminhoColecaoDenuncia}/${collecaoFirestore.FOTOS}/${idFotoServidor}`;
  }

  public getFotosFormulario():string[] {
    return denunciaRegistroPageInstance.getItemDoFormulario(componenteFormulario.FOTOS) as string[];
  }

  public getObservacaoFormulario():string {
    return denunciaRegistroPageInstance.getItemDoFormulario(componenteFormulario.OBSERVACAO);
  }

  public getTituloFormulario():string {
    return denunciaRegistroPageInstance.getItemDoFormulario(componenteFormulario.TITULO);
  }

  private getItemDoFormulario(nomeItem: componenteFormulario):any {
    return denunciaRegistroPageInstance.formularioDenuncia.get(nomeItem).value;
  }

  public getCodUsuario():number {
    return denunciaRegistroPageInstance.brComService.obtemCodUsuarioDaEmpresa(denunciaRegistroPageInstance.getCodEmpresa());
  }

  public getCodEmpresa():number {
    return denunciaRegistroPageInstance.codEmpresa;
  }

  public getNumMaxCaracteresObservacao():number {
    return NUMERO_MAX_CARACTERES_OBSERVACAO;
  }

  public getNumMaxCaracteresTitulo():number {
    return NUMERO_MAX_CARACTERES_TITULO;
  }

  public getNumMinCaracteresTitulo():number {
    return NUMERO_MIN_CARACTERES_TITULO;
  }

  public isConnectadoInternet():boolean {
    const tipoSemConexao = "none";
    if (denunciaRegistroPageInstance.network.type != tipoSemConexao) {
      return true;
    }
    return false;
  }
}


// WEBPACK FOOTER //
// ./src/pages/denunciaregistro/denunciaregistro.ts